import { SOCIAL_PLATFORM_DETAILS } from '@eventbrite/collection-carousel';
import { track } from '@eventbrite/datalayer-library';
import { Typography } from '@eventbrite/marmalade';
import React, { FunctionComponent } from 'react';
import { InfluencerType, Social } from './InfluencerCuration';
import styles from './InfluencerCuration.module.scss';

interface CSSProperties {
    '--image-url': string;
}

interface InfluencerProp {
    influencer: InfluencerType;
    source: string;
}

export const Influencer: FunctionComponent<InfluencerProp> = (props) => {
    const { influencer, source } = props;
    const { image, collection_id, title, name, social, interests } = influencer;

    const customStyle = {
        '--image-url': `url(${image})`,
    } as React.CSSProperties & CSSProperties;

    const handleOnClick = () => {
        track({
            eventName: `${source}InfluencerCollection`,
            eventData: {
                collectionId: collection_id,
            },
        });
    };
    return (
        <a
            href={`/c/${collection_id}/?utm_entry_point=${source}-influencer-collection`}
            onClick={handleOnClick}
            target="_blank"
            rel="noreferrer"
            data-heap-id={`${source}-influencer-collection`}
            className={styles.influencer_curation_events_event_card}
            key={collection_id}
        >
            <span className={styles.profile_image} style={customStyle} />
            <div className={styles.profile_details}>
                <Typography variant="body-md" className={styles.profile_title}>
                    {title}
                </Typography>
                <Typography
                    variant="heading-sm"
                    className={styles.profile_name}
                >
                    {name}
                </Typography>
                <Typography variant={'body-sm'} className={styles.interests}>
                    {interests}
                </Typography>
                <div className={styles.social_handles}>
                    {social.map((social_platform: Social) => (
                        <InfluencerSocial
                            key={social_platform.platform}
                            platformData={social_platform}
                        />
                    ))}
                </div>
            </div>
        </a>
    );
};

const InfluencerSocial = (props: { platformData: Social }) => {
    const { platform, handle } = props.platformData;
    return (
        <div key={platform} className={styles.social_platform}>
            <img src={SOCIAL_PLATFORM_DETAILS[platform].icon} />
            <Typography variant="body-sm">@{handle}</Typography>
        </div>
    );
};
